import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { CardsPromo } from '../models/cards-promo.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CardsPromoService {
  private collectionName = 'CardsPromos';

  constructor(private firestore: AngularFirestore, private storage: AngularFireStorage) {}

  getPromos(): Observable<CardsPromo[]> {
    return this.firestore
      .collection<CardsPromo>(this.collectionName, (ref) => ref.orderBy('createdAt', 'desc'))
      .snapshotChanges()
      .pipe(
        map((actions) =>
          actions.map((a) => {
            const data = a.payload.doc.data() as CardsPromo;
            const id = a.payload.doc.id;
            return { id, ...data };
          })
        )
      );
  }

  async uploadImage(file: File, id: string): Promise<string> {
    const filePath = `${this.collectionName}/${id}_${file.name}`;
    const fileRef = this.storage.ref(filePath);
    await this.storage.upload(filePath, file);
    return fileRef.getDownloadURL().toPromise();
  }

  async addPromo(promo: CardsPromo, file?: File) {
    const docRef = await this.firestore.collection(this.collectionName).add({
      text1: promo.text1,
      text2: promo.text2,
      url: promo.url || '',
      imageUrl: '',
      createdAt: new Date(),
    });

    if (file) {
      const imageUrl = await this.uploadImage(file, docRef.id);
      await docRef.update({ imageUrl });
    }
  }

  async updatePromo(id: string, data: Partial<CardsPromo>, file?: File) {
    if (file) {
      const imageUrl = await this.uploadImage(file, id);
      data.imageUrl = imageUrl;
    }
    return this.firestore.collection(this.collectionName).doc(id).update(data);
  }

  async deletePromo(id: string, imageUrl?: string) {
    await this.firestore.collection(this.collectionName).doc(id).delete();

    if (imageUrl) {
      try {
        await this.storage.refFromURL(imageUrl).delete().toPromise();
      } catch (e) {
        console.warn('⚠️ No se pudo eliminar la imagen del storage:', e);
      }
    }
  }
}
